/**
 * Returns a function, that, as long as it continues to be invoked,
 * will only trigger every N (`wait`) milliseconds.
 * If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * Derived from https://davidwalsh.name/javascript-debounce-function
 *
 * @param func the function to throttle
 * @param wait delay between two calls
 * @param immediate if true, the function is called on the leading edge, instead of the trailing
 * @returns
 */
export default function throttle(func: (arg0: unknown) => unknown, wait: number, immediate: boolean) {
  let timeout: ReturnType<typeof setTimeout> | null;
  return (...args: unknown[]) => {
    const later = () => {
      timeout = null;
      if (!immediate) func([...args]);
    };
    const callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) func([...args]);
  };
}
